/**
 * Push Notifications Lifecycle Setup
 *
 * Componente sem UI que liga o `pushNotificationsService` ao AuthContext
 * via `registerLoginHandler` / `registerLogoutHandler`. Mirror do
 * `setupAuthLifecycle.ts`.
 *
 *   - Login → `enableBackendRegistration()` — re-envia o token capturado
 *     pra que o backend faça claim do device por esse user.
 *   - Logout → `disableBackendRegistration()` — no-op por enquanto (o
 *     backend mantém a row vinculada ao último user até alguém novo
 *     logar; comportamento documentado em `ai/push-notifications.md`).
 *
 * `pushNotificationsService.prepare()` continua sendo chamado uma única
 * vez no `index.tsx` (independente de auth — esse é o ponto chave da
 * arquitetura device-first).
 */

import { useEffect } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { pushNotificationsService } from '@/lib/push'

export function PushLifecycleSetup() {
  const { registerLoginHandler, registerLogoutHandler } = useAuth()

  useEffect(() => {
    const unregisterLogin = registerLoginHandler(async () => {
      try {
        await pushNotificationsService.enableBackendRegistration()
      } catch (error) {
        console.warn('[PushLifecycle] Failed to claim push subscription:', error)
      }
    })

    const unregisterLogout = registerLogoutHandler(() => {
      pushNotificationsService.disableBackendRegistration()
    })

    return () => {
      unregisterLogin()
      unregisterLogout()
    }
  }, [registerLoginHandler, registerLogoutHandler])

  return null
}
